import * as React from "react";

// Arrow by Kirsh from the Noun Project (edited)
// https://thenounproject.com/term/arrow/1256496

export default function FieldsArrowIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 64 64" {...props} id="back">
			<path d="M15.64 62.8a4.1 4.1 0 005.8 0l27.88-27.86a4.1 4.1 0 000-5.8L21.44 1.27a4.1 4.1 0 00-5.94 5.66l.15.15 25 25-25 25a4.1 4.1 0 000 5.8z" />
		</svg>
	);
}
